import { render, staticRenderFns } from "./FicheClient.vue?vue&type=template&id=73c9b96f&scoped=true&lang=true&"
import script from "./FicheClient.vue?vue&type=script&lang=js&"
export * from "./FicheClient.vue?vue&type=script&lang=js&"
import style0 from "./FicheClient.vue?vue&type=style&index=0&id=73c9b96f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c9b96f",
  null
  
)

export default component.exports